<template>
  <div>
    <el-cascader :size="size" :placeholder="placeholder" v-model="localValue" :options="options"
                 :props="{ multiple: multiple, label: name, value: code}" :collapse-tags="collapseTags" :filterable="filterable"
                 :disabled="disabled" :style="{'display':display,'width':'100%'}" clearable @change="changeCascader"/>
  </div>
</template>
<script>

export default {
  name: "MyCascader",
  props: {
    value: {
      type: [String,Number,Array],
      default: () => {
        return ""
      }
    },
    multiple: {
      type: Boolean,
      default: ()=>{return true}
    },
    disabled: {
      type: Boolean,
      default: ()=>{return false}
    },
    collapseTags: {
      type: Boolean,
      default: ()=>{return false}
    },
    filterable: {
      type: Boolean,
      default: ()=>{return false}
    },
    display: {
      type: String,
      default: ()=>{return 'inline-block'}
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    code:{
      type: String,
      default: ()=>{return 'value'}
    },
    name:{
      type: String,
      default: ()=>{return 'label'}
    },
    placeholder: {
      type: String,
      default: () => {
        return '请选择'
      }
    },
    size: {
      type: String,
      default: () => {
        return 'small '
      }
    },
  },
  watch: {
    value:{
      handler(newVal,oldVal){
        if (newVal !== oldVal){
          this.formatLocalVal(newVal)
        }
      }
    }
  },
  computed:{
  },
  data() {
    return {
      localValue:[]
    }
  },
  mounted() {
    this.formatLocalVal(this.$props.value)
  },
  methods: {
    formatLocalVal(newVal){
      let localVal = [];
      if (newVal && newVal.length > 0){
        let dataValues = newVal.split(",");
        this.$props.options.forEach(rootItem => {
          /*const treeLoadValues = this.traverseTreeValue(rootItem, dataValues);
          console.log("treeLoadValues:"+JSON.stringify(treeLoadValues));
          localVal.push(treeLoadValues);*/
          let nodeValue = dataValues.find(value => value === rootItem[this.code]);
          if (!rootItem.children && nodeValue){
              localVal.push([nodeValue])
          }else if(rootItem.children){
            rootItem.children.forEach(secondChildItem => {
              let secondChildValue = dataValues.find(value => value === secondChildItem[this.code]);
              if (!secondChildItem.children && secondChildValue){
                localVal.push([nodeValue, secondChildValue]);
              }else if(secondChildItem.children){
                secondChildItem.children.forEach(threeChildItem => {
                  let threeChildValue = dataValues.find(value => value === threeChildItem[this.code]);
                  if (!threeChildItem.children && threeChildValue){
                    localVal.push([nodeValue, secondChildValue, threeChildValue]);
                  }else if(threeChildItem.children){
                    threeChildItem.children.forEach(foureChildItem => {
                      let foureChildValue = dataValues.find(value => value === foureChildItem[this.code]);
                      if (!foureChildItem.children && foureChildValue){
                        localVal.push([nodeValue, secondChildValue, threeChildValue, foureChildValue]);
                      }else if(foureChildItem.children){
                        foureChildItem.children.forEach(fiveChildItem => {
                          let fiveChildValue = dataValues.find(value => value === fiveChildItem[this.code]);
                          if (!fiveChildItem.children && fiveChildValue){
                            localVal.push([nodeValue, secondChildValue, threeChildValue, foureChildValue, fiveChildValue]);
                          }else if(fiveChildItem.children){

                          }
                        })
                      }
                    })
                  }
                })
              }
            })
          }
        })
      }
      this.localValue = localVal
      return localVal;
    },
    traverseTreeValue(tree, dataValues, path = []) {
      let treeValue = dataValues.find(value => value === tree[this.code]);
      let currentValue = [...path, treeValue];
      if (!tree.children && treeValue){
        return currentValue;
      }else if (tree.children && tree.children.length > 0) {
          let childValue = this.traverseTreeValue(tree.children, dataValues, currentValue);
          if(childValue !== null){
            return childValue;
          }
      }
      return null;
    },
    changeCascader(value){
      let dataStr = "";
      let dataArr = [];
      value.forEach(item=>{
        if(this.multiple){
          item.forEach(it=>{
            if (dataArr.indexOf(it) === -1){
              dataArr.push(it)
            }
          })
        }else{
          dataArr.push(item)
        }
      })
      dataStr = dataArr.join(",");
      this.$emit("update:value",dataStr)
      this.$emit("on-change",dataStr)
    }
  },
};
</script>
<style lang="postcss" scoped>
.checkbox_disable {
  height: auto;
  -moz-opacity: 0.8;
  opacity: 0.8;
  pointer-events: none;
  -ms-filter: blur(10px);
  filter: blur(10px);
}
</style>
